import { SelectedGroupsType } from '@/features/analytics/model/types'
import { CrossSVGIcon, GearSVGIcon, TrashIcon } from '@/shared/assets'
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuTrigger,
    Toast,
} from '@/shared/ui'
import { UseMutationResult } from '@tanstack/react-query'
import { Check, XIcon } from 'lucide-react'
import { useCallback, useState } from 'react'

type DropdownMenuGroupsProps = {
    selectedGroups: SelectedGroupsType
    clearSelectedGroupsById: (groupId: number) => void
    deleteMutation: UseMutationResult<number, Error, number, unknown>
    workspaceId: number
}

export function DropdownMenuGroups({
    selectedGroups,
    clearSelectedGroupsById,
    deleteMutation,
    workspaceId,
}: DropdownMenuGroupsProps) {
    const handleDeselect = useCallback(() => {
        clearSelectedGroupsById(workspaceId)
    }, [clearSelectedGroupsById, workspaceId])

    const [toastMessage, setToastMessage] = useState('')
    const handleDelete = useCallback(() => {
        const groupIds = selectedGroups[workspaceId]
        for (let i = 0; i < groupIds.length; i++) {
            deleteMutation.mutate(groupIds[i], {
                onError: (res: any) => {
                    setToastMessage(
                        toastMessage + '\n' + res.response.data.message
                    )
                },
            })
        }
        setShowDeleteConfirmation(false)
        handleDeselect()
    }, [
        deleteMutation,
        handleDeselect,
        selectedGroups,
        toastMessage,
        workspaceId,
    ])

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false)

    const handleDeleteConfirmation = (event: React.MouseEvent) => {
        if (!showDeleteConfirmation) {
            setShowDeleteConfirmation(true)
            event.preventDefault()
        }
    }

    const handleCancelDelete = (event: React.MouseEvent) => {
        event.stopPropagation()
        setShowDeleteConfirmation(false)
    }

    return (
        <>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <div>
                        <GearSVGIcon className="h-[17px] w-[17px]" />
                    </div>
                </DropdownMenuTrigger>
                <DropdownMenuContent
                    side="right"
                    align="start"
                    className="w-[190px] border-[#E9E9ED] bg-white"
                >
                    <DropdownMenuGroup className="gap-2 rounded-xl p-1">
                        <DropdownMenuItem
                            onClick={handleDeselect}
                            className="cursor-pointer rounded-xl p-2 text-[13px] hover:bg-[#F2F6FD]"
                        >
                            <span>Снять выделение</span>
                        </DropdownMenuItem>
                        <DropdownMenuItem
                            onClickCapture={handleDeleteConfirmation}
                            className="cursor-pointer justify-between rounded-xl p-2 text-[13px] hover:bg-[#F2F6FD]"
                        >
                            <span>Удалить</span>
                            {showDeleteConfirmation ? (
                                <div className="flex justify-between">
                                    <div onClick={handleDelete}>
                                        <Check className="ml-2 cursor-pointer text-[#056FFF]" />
                                    </div>
                                    <div onClick={handleCancelDelete}>
                                        <XIcon className="ml-2 cursor-pointer" />
                                    </div>
                                </div>
                            ) : (
                                <img src={TrashIcon} />
                            )}
                        </DropdownMenuItem>
                    </DropdownMenuGroup>
                </DropdownMenuContent>
            </DropdownMenu>
            <Toast
                icon={<CrossSVGIcon />}
                message={toastMessage}
                visible={!!toastMessage}
                onClose={() => setToastMessage('')}
                greenSwooshIcon={true}
            />
        </>
    )
}
